module.exports = __webpack_public_path__ + "media/stylesheets/images/Kimihiro Higuchi-d5fa37ad632d891401afa47be2acdd3d.jpg";